import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { CheckoutV2 } from 'src/apps/checkout/app/V2/Page';
import { redirectSubscribedUserToSubscriptions } from 'src/utils/redirectSubscribedToSubscriptions';

const searchSchema = z.object({
  promotion_code: z.string().optional(),
  redirect_status: z.string().optional(),
});

export const Route = createFileRoute('/_auth/_only-header/store/checkout')({
  validateSearch: zodValidator(searchSchema),
  beforeLoad: async ({ context }) => {
    if (!context.featureFlags.EnableCheckoutV2) {
      throw redirect({
        to: '/store',
      });
    }

    await redirectSubscribedUserToSubscriptions(context);
  },
  component: () => <CheckoutV2 />,
});
